import React from "react";
import { NavLink, Outlet, Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const navLinkClass = ({ isActive }) =>
  `nav-link ${isActive ? "active fw-bold" : ""}`;

export default function AdminLayout() {
  const navigate = useNavigate();
  const { signOut, profile } = useAuth();

  return (
    <div style={{ minHeight: "100vh", background: "#f4f6f8" }}>
      <nav
        className="navbar navbar-expand-lg navbar-dark"
        style={{ background: "#1a2332" }}
      >
        <div className="container-fluid">
          <Link className="navbar-brand" to="/admin/dashboard">
            PCF Admin
          </Link>
          <span className="navbar-text small me-3 d-none d-md-inline text-white-50">
            {profile?.email}
          </span>
          <div className="navbar-nav ms-auto flex-row gap-2 align-items-center">
            <Link className="btn btn-sm btn-outline-light" to="/">
              View site
            </Link>
            <button
              type="button"
              className="btn btn-sm btn-warning"
              onClick={async () => {
                await signOut();
                navigate("/", { replace: true });
              }}
            >
              Sign out
            </button>
          </div>
        </div>
      </nav>

      <div className="container-fluid">
        <div className="row">
          <aside
            className="col-md-3 col-lg-2 py-4 px-3 border-end bg-white"
            style={{ minHeight: "calc(100vh - 56px)" }}
          >
            <nav className="nav flex-column gap-1">
              <NavLink to="/admin/dashboard" className={navLinkClass}>
                Dashboard
              </NavLink>
              <NavLink to="/admin/members" className={navLinkClass}>
                Members
              </NavLink>
              <NavLink to="/admin/events" className={navLinkClass}>
                Events
              </NavLink>
              <NavLink to="/admin/cms" className={navLinkClass}>
                CMS
              </NavLink>
              <NavLink to="/admin/images" className={navLinkClass}>
                Images
              </NavLink>
            </nav>
          </aside>
          <main className="col-md-9 col-lg-10 py-4 px-4">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}
